export default "__VITE_ASSET__4be87a6e__"